import gql from "graphql-tag";

/**
 * GraphQL Mutations for user authentication
 */

const ForgotPasswordMutation = gql`
  mutation($data: ForgotPasswordInput!) {
    forgotPassword(data: $data) {
      status
      message
    }
  }
`;

export default ForgotPasswordMutation